import gql from 'graphql-tag';

export const attendanceStepFragment = gql`
  fragment attendanceStepFieldsParts on AttendanceStep {
    id
    componentName
  }
`;

export const recursiveAttendanceStepsFragment = gql`
  fragment recursiveAttendanceSteps on AttendanceStep {
    actions
  }
  ${attendanceStepFragment}
`;

export const guidedAttendanceFragment = gql`
  fragment guidedAttendanceParts on GuidedAttendance {
    attendanceStepId
    attendanceStep {
      ...attendanceStepFieldsParts
      ...recursiveAttendanceSteps
    }
  }
  ${attendanceStepFragment}
  ${recursiveAttendanceStepsFragment}
`;

export const guidedAttendanceTreeFragment = gql`
  fragment guidedAttendanceTreeParts on GuidedAttendanceResponse {
    tree: guidedAttendance {
      ...guidedAttendanceParts
    }
    context
  }
  ${guidedAttendanceFragment}
`;

export const condominiumDwellersFragment = gql`
  fragment condominiumDwellersParts on CondominiumDwellers {
    id
    name
    personContextId
  }
`;

export const condominiumUnityGroupFragment = gql`
  fragment condominiumUnityGroupParts on CondominiumUnityGroup {
    id
    description
    treeNodeId
  }
`;

export const condominiumUnitiesFragment = gql`
  fragment condominiumUnitiesParts on CondominiumUnities {
    id
    description
    treeNodeId
    unityGroup {
      ...condominiumUnityGroupParts
    }
    dwellers {
      ...condominiumDwellersParts
    }
  }
  ${condominiumUnityGroupFragment}
  ${condominiumDwellersFragment}
`;

export const unityDwellersResponseFragment = gql`
  fragment unityDwellersResponseParts on UnityDwellersResponse {
    unities {
      ...condominiumUnitiesParts
    }
  }
  ${condominiumUnitiesFragment}
`;

export const callPriorityProfileFragment = gql`
  fragment callPriorityProfileParts on CallPriorityProfile {
    id
    name
    fieldName
  }
`;

export const callPriorityPhoneFragment = gql`
  fragment callPriorityPhoneParts on CallPriorityPhone {
    destinationKind
    destination
    codAta
  }
`;

export const callPriorityFragment = gql`
  fragment callPriorityParts on CallPriority {
    personContextId
    name
    callPriority
    uniTyId
    observation
    phones {
      ...callPriorityPhoneParts
    }
    profile {
      ...callPriorityProfileParts
    }
  }
  ${callPriorityPhoneFragment}
  ${callPriorityProfileFragment}
`;

export const continuousAttendanceAttendantFragment = gql`
  fragment continuousAttendanceAttendantParts on ContinuousAttendanceAttendant {
    id
    name
    email
  }
`;

export const continuousAttendanceUnityFragment = gql`
  fragment continuousAttendanceUnityParts on ContinuousAttendanceUnity {
    id
    name
    description
  }
`;

export const continuousAttendanceUnitiesFragment = gql`
  fragment continuousAttendanceUnitiesParts on ContinuousAttendanceUnities {
    unityGroup {
      ...continuousAttendanceUnityParts
    }
    unity {
      ...continuousAttendanceUnityParts
    }
    status
  }
  ${continuousAttendanceUnityFragment}
`;

export const continuousAttendanceFragment = gql`
  fragment continuousAttendanceParts on ContinuousAttendance {
    eventId
    status
    identifier
    dweller
    creationDate
    triageId
    placeName
    treatment
    unityGroup {
      ...continuousAttendanceUnityParts
    }
    unity {
      ...continuousAttendanceUnityParts
    }
    attendant {
      ...continuousAttendanceAttendantParts
    }
    unities {
      ...continuousAttendanceUnitiesParts
    }
  }
  ${continuousAttendanceUnitiesFragment}
  ${continuousAttendanceUnityFragment}
  ${continuousAttendanceAttendantFragment}
`;

export const continuousAttendanceResponseFragment = gql`
  fragment continuousAttendanceResponseParts on ContinuousAttendanceResponse {
    attendances {
      ...continuousAttendanceParts
    }
  }
  ${continuousAttendanceFragment}
`;

export const preRegisterAuthorizationFragment = gql`
  fragment preRegisterAuthorizationParts on PreRegisterAuthorization {
    name
    type
    status
    observation
    profileName
    guestId
    personContextId
    transientPersonId
    hasRegisteredFace
    phoneNumber
    vehiclePlate
    documentCpf
    companyName
    transientPersonType
  }
`;

export const transientPersonResponseFragment = gql`
  fragment transientPersonResponseParts on TransientPersonResponse {
    id
    name
  }
`;

export const transientPersonSettingFragment = gql`
  fragment transientPersonSettingParts on TransientPersonSetting {
    id
    name
    type
    order
    isRequired
  }
`;

export const sideMenuFooterViewTemplateFragment = gql`
  fragment sideMenuFooterViewTemplateParts on SideMenuFooterViewTemplate {
    componentName
  }
`;

export const guidedAttendanceViewTemplateSideMenuFragment = gql`
  fragment guidedAttendanceViewTemplateSideMenuParts on GuidedAttendanceViewTemplateSideMenu {
    menu
    footer {
      ...sideMenuFooterViewTemplateParts
    }
  }
  ${sideMenuFooterViewTemplateFragment}
`;

export const guidedAttendanceViewTemplateDetailInfoFragment = gql`
  fragment guidedAttendanceViewTemplateDetailInfoParts on GuidedAttendanceViewTemplateDetailInfo {
    componentName
  }
`;

export const guidedAttendanceViewTemplateFragment = gql`
  fragment guidedAttendanceViewTemplateParts on GuidedAttendanceViewTemplate {
    eventType
    detailInfo {
      ...guidedAttendanceViewTemplateDetailInfoParts
    }
    sideMenu {
      ...guidedAttendanceViewTemplateSideMenuParts
    }
  }
  ${guidedAttendanceViewTemplateDetailInfoFragment}
  ${guidedAttendanceViewTemplateSideMenuFragment}
`;

export const lastAttendancesByEventTypeFragment = gql`
  fragment lastAttendancesByEventTypeParts on LastAttendancesByEventTypeTemplate {
    additionalInformation
    eventId
    attendant {
      ...continuousAttendanceAttendantParts
    }
    status
    creationDate
  }
  ${continuousAttendanceAttendantFragment}
`;

export const condominiumCameraLiveFragment = gql`
  fragment condominiumCameraLiveParts on CondominiumCameraLive {
    url
  }
`;
export const condominiumCameraLiveV2Fragment = gql`
  fragment condominiumCameraLiveV2Parts on CondominiumCameraLiveV2 {
    placeId
    placeName
    url
    cameraType
    cameraId
  }
`;

const dwellerDocumentFragment = gql`
  fragment dwellerDocumentParts on DwellerDocument {
    type
    value
  }
`;

export const dwellersWithDocumentsResponseFragment = gql`
  fragment dwellersWithDocumentsResponseParts on DwellersWithDocumentsResponse {
    id
    name
    documents {
      ...dwellerDocumentParts
    }
  }
  ${dwellerDocumentFragment}
`;

export const dwellerPhoneFragment = gql`
  fragment dwellerPhoneParts on DwellerPhone {
    personContextId
    name
    phones
  }
`;

const condominiumRuleQuestionAnswerFragment = gql`
  fragment condominiumRuleQuestionAnswerParts on CondominiumRuleQuestionAnswer {
    questionAnswerType
    yesNoAnswer
    scheduleAnswer
    textAnswer
    condominiumId
    condoRuleQuestionId
    id
  }
`;

export const condominiumRuleQuestionFragment = gql`
  fragment condominiumRuleQuestionParts on CondominiumRuleQuestion {
    id
    description
    subtriageId
    order
    answer {
      ...condominiumRuleQuestionAnswerParts
    }
  }
  ${condominiumRuleQuestionAnswerFragment}
`;

const descriptionTranslateFragment = gql`
  fragment descriptionTranslateParts on DescriptionTranslate {
    pt
    es
    en
  }
`;
const activityTriageFragment = gql`
  fragment activityTriageParts on ActivityTriage {
    id
    description {
      ...descriptionTranslateParts
    }
  }
  ${descriptionTranslateFragment}
`;

const activitySubtriageFragment = gql`
  fragment activitySubtriageParts on ActivitySubtriage {
    id
    description {
      ...descriptionTranslateParts
    }
  }
  ${descriptionTranslateFragment}
`;

export const condominiumRuleQuestionsWithTriageAndSubtriageFragment = gql`
  fragment condominiumRuleQuestionsWithTriageAndSubtriageParts on CondominiumRuleQuestionsWithTriageAndSubtriage {
    triage {
      ...activityTriageParts
    }
    subtriage {
      ...activitySubtriageParts
    }
    questionsAndAnswer {
      ...condominiumRuleQuestionParts
    }
  }
  ${condominiumRuleQuestionFragment}
  ${activityTriageFragment}
  ${activitySubtriageFragment}
`;

export const condominiumUnityFragment = gql`
  fragment condominiumUnityParts on CondominiumUnity {
    id
    description
    treeNodeId
    unityGroup {
      ...condominiumUnityGroupParts
    }
  }
  ${condominiumUnityGroupFragment}
`;

export const eventPersonProfileFragment = gql`
  fragment eventPersonProfileParts on EventPersonProfile {
    id
    name
    fieldName
  }
`;

export const eventPersonAdditionalContactFragment = gql`
  fragment eventPersonAdditionalContactParts on EventPersonAdditionalContact {
    contactTypeId
    contact
  }
`;

export const eventPersonFragment = gql`
  fragment eventPersonParts on EventPerson {
    id
    name
    email
    phone
    profile {
      ...eventPersonProfileParts
    }
    unity {
      ...condominiumUnityParts
    }
    unityGroup {
      ...condominiumUnityGroupParts
    }
    additionalContacts {
      ...eventPersonAdditionalContactParts
    }
  }
  ${eventPersonProfileFragment}
  ${eventPersonAdditionalContactFragment}
  ${condominiumUnityFragment}
  ${condominiumUnityGroupFragment}
`;

const unityDwellerCollectionFragment = gql`
  fragment unityDwellerCollectionParts on UnityDwellerCollection {
    id
    name
    personId
    profileId
    phone
    email
    unity {
      ...condominiumUnityParts
    }
  }
  ${condominiumUnityFragment}
`;

const unityDwellerPaginationFragment = gql`
  fragment unityDwellerPaginationParts on UnityDwellerPagination {
    page
    pageSize
    hasNextPage
  }
`;

export const unityDwellerPaginatedSearchResponseFragment = gql`
  fragment unityDwellerPaginatedSearchResponseParts on UnityDwellerPaginatedSearchResponse {
    collection {
      ...unityDwellerCollectionParts
    }
    pagination {
      ...unityDwellerPaginationParts
    }
  }
  ${unityDwellerCollectionFragment}
  ${unityDwellerPaginationFragment}
`;

const deviceAudioCall = gql`
  fragment deviceAudioCallParts on DeviceAudioCall {
    destination
    destinationKind
  }
`;

const deviceToOpenDoorFragment = gql`
  fragment deviceToOpenDoorParts on DeviceToOpenDoor {
    id
    name
    parentDeviceId
    deviceTypeId
    serialNumber
    serializedParams
    ip
    doorId
    commands
    doorStatus
    keepOpenReason
    audioCall {
      ...deviceAudioCallParts
    }
    placeId
    deviceModelId
    isOnline
  }
  ${deviceAudioCall}
`;

const placeInterlockedBaseFragment = gql`
  fragment placeInterlockedBaseParts on PlaceInterlockedBase {
    id
    name
  }
`;

const interlockedPlaceToOpenDoorsFragment = gql`
  fragment interlockedPlaceToOpenDoorsParts on InterlockedPlaceToOpenDoors {
    id
    name
    places {
      ...placeInterlockedBaseParts
    }
  }
  ${placeInterlockedBaseFragment}
`;

const placeToOpenDoorFragment = gql`
  fragment placeToOpenDoorParts on PlaceToOpenDoor {
    id
    name
    order
    serializedParams
    comments
    interlocked {
      ...interlockedPlaceToOpenDoorsParts
    }
    devices {
      ...deviceToOpenDoorParts
    }
  }
  ${interlockedPlaceToOpenDoorsFragment}
  ${deviceToOpenDoorFragment}
`;

export const placesToOpenDoorResponseFragment = gql`
  fragment placesToOpenDoorResponseParts on PlacesToOpenDoorResponse {
    places {
      ...placeToOpenDoorParts
    }
  }
  ${placeToOpenDoorFragment}
`;

export const transientPersonDetailsFragment = gql`
  fragment transientPersonDetailsParts on TransientPersonDetails {
    name
    value
    type
  }
`;

export const transientPersonWithDetailsFragment = gql`
  fragment transientPersonWithDetailsParts on TransientPersonWithDetails {
    id
    name
    partnerPersonContextId
    type
    faceId
    transientPersonDetails {
      ...transientPersonDetailsParts
    }
    faceUrl
  }
  ${transientPersonDetailsFragment}
`;

export const externalExtensionResponseFragment = gql`
  fragment externalExtensionResponseParts on ExternalExtensionResponse {
    id
    name
    audioCall {
      ...deviceAudioCallParts
    }
  }
  ${deviceAudioCall}
`;

export const condominiumIotDevicesResponseFragment = gql`
  fragment condominiumIotDevicesResponseParts on CondominiumIotDevicesResponse {
    iotDevices {
      id
      name
      serialNumber
      isOnline
    }
    alarmDevices {
      id
      name
      serialNumber
      isOnline
    }
  }
`;
